import React from 'react';
import { motion } from 'framer-motion';
import { PlayIcon } from 'lucide-react';
import { twMerge } from 'tailwind-merge';
import { Equalizer } from './ui/Equalizer';
import { useSamplePlayer } from '../hooks/useSamplePlayer';
import { spring } from '../utils/motion';
import type { SongKey } from '../types/marketplace';
interface SongRowProps {
  song: SongKey;
  compact?: boolean;
  trailing?: React.ReactNode;
  className?: string;
}
export function SongRow({
  song,
  compact,
  trailing,
  className
}: SongRowProps) {
  const {
    playing,
    toggle
  } = useSamplePlayer(song.id);
  return <div className={twMerge('flex min-w-0 items-center gap-3', className)} data-id="element-691" data-mp="1au2029hb8fxi">
      <motion.button type="button" onClick={e => {
      e.stopPropagation();
      toggle();
    }} disabled={!song.sample} whileTap={{
      scale: 0.88
    }} transition={spring.snappy} aria-label={song.sample ? playing ? `Stop ${song.title} sample` : `Play ${song.title} sample` : 'No sample uploaded'} aria-pressed={playing} className={twMerge('grid shrink-0 place-items-center rounded-full transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand disabled:cursor-not-allowed', compact ? 'h-8 w-8' : 'h-10 w-10', playing ? 'bg-brand text-on-brand' : song.sample ? 'bg-ink text-bg' : 'bg-surface-2 text-ink-3')} data-id="element-692" data-mp="1arz3t7pkdqkc">
        {playing ? <Equalizer playing className="h-3.5" data-id="element-693" data-mp="te0d2wg7tak4" /> : <PlayIcon className={compact ? 'ml-0.5 h-3.5 w-3.5' : 'ml-0.5 h-4 w-4'} fill="currentColor" data-id="element-694" data-mp="tfjpgbyr31gm" />}
      </motion.button>
      <div className="min-w-0 flex-1" data-id="element-695" data-mp="13c6bv56q60kr">
        <p className={twMerge('truncate font-bold leading-tight', compact ? 'text-sm' : 'text-[15px]')} data-id="element-696" data-mp="13b4yuv65f40e">{song.title}</p>
        <p className="truncate text-[13px] text-ink-3" data-id="element-697" data-mp="fl0ycwo9bkdm">
          {song.artist} · {song.genre}
        </p>
      </div>
      {trailing}
    </div>;
}